import { useEffect, useState, useContext } from "react";
import { UserContext } from "../../../contexts/userProvider";
import { EquipamentosContext } from "../../../contexts/equipamentosProvider";
import { BiX } from "react-icons/bi";
import BaseInput from "../../General/FormsComp/Input/BaseInput";
import BaseButton from "../../General/FormsComp/Button/BaseButton";

const AlterModal = ({ closeModal, grupo }) => {
  const { setAlert } = useContext(UserContext);
  const { updateEquipamento } = useContext(EquipamentosContext);
  const [maxEquipamentos, setMaxEquipamentos] = useState("");

  useEffect(() => {
    if (grupo) {
      setMaxEquipamentos(grupo.maxEquipamentos);
    }
  }, []);

  const handleChange = (e) => {
    setMaxEquipamentos(e.target.value);
  };

  const handleSave = () => {
    if (!maxEquipamentos) {
      setAlert({
        visible: true,
        title: "Atenção!",
        placeholder: "Preencha o campo de quantidade máxima",
        confirm: false,
        type: "warning",
      });
      return;
    }
    if (maxEquipamentos < grupo.totalPatrimoniosNfs + grupo.totalPatrimonios) {
      setAlert({
        visible: true,
        title: "Atenção!",
        placeholder:
          "A quantidade máxima não pode ser menor que a quantidade de equipamentos instalados",
        confirm: false,
        type: "warning",
      });
      return;
    }
    if (maxEquipamentos === grupo.maxEquipamentos) {
      setAlert({
        visible: true,
        title: "Atenção!",
        placeholder: "Nenhuma alteração foi feita",
        confirm: false,
        type: "warning",
      });
      return;
    }
    updateEquipamento(grupo.equipamentoId, maxEquipamentos, grupo.clienteId);
    closeModal();
  };

  return (
    <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-100 p-4'>
      <div className='bg-white dark:bg-gray-800 rounded-3xl shadow-vox-2xl max-w-lg w-full mx-4 max-h-[90vh] overflow-hidden flex flex-col'>
        {/* Header */}
        <div className='flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700'>
          <h1 className='text-2xl font-bold text-gray-900 dark:text-white'>
            Editar Limite de Equipamento
          </h1>
          <button 
            onClick={() => closeModal()} 
            className='p-2 text-gray-500 hover:text-red-500 dark:text-gray-400 dark:hover:text-red-400 transition-colors duration-200 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700'
          >
            <BiX className='w-6 h-6' />
          </button>
        </div>

        {/* Content */}
        <div className='flex-1 overflow-auto p-6'>
          <div className='space-y-6'>
            <div className='bg-gray-50 dark:bg-gray-700 rounded-lg p-4'>
              <label className='block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2'>
                Grupo Equipamento
              </label>
              <div className='text-lg font-semibold text-gray-900 dark:text-white'>
                {grupo.grupoNome}
              </div>
            </div>

            <BaseInput
              label="Quantidade Máxima"
              name="maxEquipamentos"
              type="number"
              value={maxEquipamentos}
              onChange={handleChange}
              placeholder="Digite a quantidade máxima"
              required
            />

            <div className='bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4'>
              <label className='block text-sm font-medium text-blue-700 dark:text-blue-300 mb-2'>
                Equipamentos Instalados
              </label>
              <div className='text-2xl font-bold text-blue-600 dark:text-blue-400'>
                {grupo.totalPatrimoniosNfs + grupo.totalPatrimonios}
              </div>
              <p className='text-xs text-blue-600 dark:text-blue-400 mt-1'>
                Total de equipamentos já instalados
              </p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-gray-200 dark:border-gray-700 flex justify-end space-x-3">
          <BaseButton onClick={() => closeModal()} variant="ghost" size="md">
            Cancelar
          </BaseButton>
          <BaseButton onClick={() => handleSave()} variant="primary" size="md">
            Salvar Alterações
          </BaseButton>
        </div>
      </div>
    </div>
  );
};

export default AlterModal;
